import { render, staticRenderFns } from "./LanguagePopup.vue?vue&type=template&id=3f9b373c&scoped=true"
import script from "./LanguagePopup.vue?vue&type=script&lang=js"
export * from "./LanguagePopup.vue?vue&type=script&lang=js"
import style0 from "./LanguagePopup.vue?vue&type=style&index=0&id=3f9b373c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9b373c",
  null
  
)

export default component.exports